import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { map } from 'rxjs'
import { BaseResponse } from '@services/api/api-base.service'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import { Paginate } from '@models/paginate.model'
import { ElectronicProcessPaginationRun } from '@models/planning/electronic-process-pagination.model'

/**
 * Histórico e ações da paginação do processo eletrônico (spec 002). Publicar e reprocessar continuam no
 * `ElectronicProcessService` e respondem só o `id` do processo: a execução criada chega pelo tópico do processo ou
 * por `latest`.
 */
@Injectable({
	providedIn: 'root'
})
export class ElectronicProcessPaginationService extends ManagementApiBaseService<unknown> {
	private readonly source = 'electronic-processes'

	constructor(override http: HttpClient) {
		super(http)
	}

	/** Execuções do processo, da mais recente para a mais antiga. */
	history(processId: string, page = 0, size = 10) {
		const params = new HttpParams().set('page', page).set('size', size)

		return this.get<Paginate<ElectronicProcessPaginationRun>>(`${this.source}/${processId}/pagination-runs`, params).pipe(
			map(response => ({ ...response, content: (response?.content ?? []).map(it => new ElectronicProcessPaginationRun(it)) }))
		)
	}

	/** A execução mais recente do processo (a ativa, quando há uma). */
	latest(processId: string) {
		return this.history(processId, 0, 1).pipe(map(page => page.content[0] ?? null))
	}

	detail(processId: string, runId: string) {
		return this.get<ElectronicProcessPaginationRun>(`${this.source}/${processId}/pagination-runs/${runId}`).pipe(
			map(response => new ElectronicProcessPaginationRun(response))
		)
	}

	/** Aplica uma simulação revisada: devolve a execução da renumeração. 409 se é preciso simular de novo. */
	apply(processId: string, simulationId: string) {
		return this.post<unknown, ElectronicProcessPaginationRun>(`${this.source}/${processId}/pagination-runs/${simulationId}/apply`).pipe(
			map(response => new ElectronicProcessPaginationRun(response))
		)
	}

	/** Nova tentativa de documento com falha na paginação, em processo publicado. */
	retryDocument(processId: string, documentId: string) {
		return this.post<unknown, BaseResponse>(`${this.source}/${processId}/documents/${documentId}/pagination/retry`)
	}
}
